exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "nylas-scheduler-editor{box-shadow:none !important;width:100%}nylas-scheduler-editor::part(editor__footer-cancel),nylas-scheduler-editor::part(net__footer-cancel){display:none !important}nylas-scheduler-editor::part(nse__header){width:revert}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/scheduling-page/styles/NylasSchedulerEditor.scss
// module id = 6254
// module chunks = 0